<template>
    <div>
        <b-form>
            <div class="animated fadeIn">

            <b-row>
                <b-col cols="auto" class="mr-auto">
                
                </b-col>
                <b-col cols="auto" class="">
                <b-form-group>
                    <b-button variant="github" class="mr-1 btn-brand" @click="openCategoryModal(null)"><i class="fa fa-plus"></i><span>Incluir Item</span></b-button>
                </b-form-group>
                </b-col>
            </b-row>
                
                
            <b-row>
                <b-col md="12">
                
                <b-table :items="items"
                    :fields="categoryTable.fields" 
                    :select-mode="categoryTable.selectMode" 
                    responsive="sm" 
                    primary-key="id" 
                    :tbody-transition-props="categoryTable.transProps" 
                    sort-icon-left
                    @row-clicked="rowClicked"
                    per-page="50" 
                    current-page="1" 
                    :busy="categoryTable.isBusy" 
                    hover striped>

                    <template #table-busy>
    
                    <div class="text-center text-danger my-2">
    
                        <b-spinner class="align-middle"></b-spinner>
    
                        <strong>Carregando...</strong>
    
                    </div>
                    </template>
                                
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                        
                                        <span aria-hidden="true">&check;</span>
                        
                                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                                </template>

                    
                    <template v-slot:cell(action)="data">
                    <!--<c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> -->
                    <b-button size="sm" variant="dark" @click="editDocument(data.item)" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                    </template>

                    <template v-slot:cell(st)="data">
                        <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                
                                
                </b-table>
                
                </b-col>
            </b-row>

            </div>
        </b-form>

        <b-modal
            v-model="categoryModal"
            id="category-modal"
            centered
            hide-footer
            title="Categoria"
            size="lg">
            <b-card>

            </b-card>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

export default {
    name: 'productSelectComponent',
    props: {
        companyId: String
    },
    components: {
       
    },
    data: () => {
        return {
            selectedItem: null,
            categoryModal: false,
            items: [],
            categoryTable: {
                isBusy: false,
                fields: [
                    { key: 'name', label: 'Item', sortable: true },
                    { key: 'quantity', label: 'Quantidade', sortable: true },
                    { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
                ],
                selectMode: 'single', 
                transProps: {
                    name: 'flip-list'
                }
            }

        }
    },
    methods: {
        rowClicked(item) {
            console.log("Linha clicada")
            this.selectedItem = item
        },
        openCategoryModal() {
            this.categoryModal = true
        },
        closeCategoryModal() {
            this.categoryModal = false
        }
    }
}
</script>